import { render, staticRenderFns } from "./SuitAmountSummary.vue?vue&type=template&id=dfb9cc40&"
import script from "./SuitAmountSummary.vue?vue&type=script&lang=js&"
export * from "./SuitAmountSummary.vue?vue&type=script&lang=js&"
import style0 from "./SuitAmountSummary.vue?vue&type=style&index=0&id=dfb9cc40&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports